import { appThemeOptions, PrimaryColor } from "@/theme";
import { createTheme, PaletteMode, useMediaQuery } from "@mui/material";
import { merge } from "lodash";
import { useMemo } from "react";

export default function usePrefersThemeColorScheme(mode?: PaletteMode) {
  const prefersDarkMode = useMediaQuery(
    `(prefers-color-scheme: ${mode || "dark"})`
  );

  const theme = useMemo(() => {
    return createTheme(
      merge(appThemeOptions, {
        palette: {
          mode: prefersDarkMode ? "dark" : "light",
          background: prefersDarkMode
            ? {
                default: "#EFEFEF",
                paper: PrimaryColor,
              }
            : {
                default: "#EFEFEF",
                paper: "#EFEFEF",
              },
        },
      })
    );
  }, [prefersDarkMode]);
  return theme;
}

export function useForceThemeColorScheme(mode: PaletteMode) {
  const theme = useMemo(() => {
    return createTheme(
      merge(appThemeOptions, {
        palette: {
          mode: mode,
          background:
            mode === "dark"
              ? {
                  default: "#EFEFEF",
                  paper: PrimaryColor,
                }
              : {
                  default: "#EFEFEF",
                  paper: "#EFEFEF",
                },
        },
      })
    );
  }, [mode]);
  return theme;
}
